<img
  [src]="imageSrc"
  class="popupPosition"
  (click)="$event.preventDefault(); $event.stopPropagation(); op.toggle($event)" />

<p-overlayPanel
  styleClass="containerPopUpInfo mx-5 md:-ml-10"
  (onShow)="toggleImage()"
  (onHide)="toggleImage()"
  #op>
  <ng-template pTemplate="content">
    <div *ngIf="popUpInfo && popUpInfo.type == direction.vertical" class="mx-2 my-2">
      <div class="my-2" *ngFor="let text of popUpInfo.texts; let i = index">
        <p
          [ngClass]="{
            'text-P whitespace-pre-line': i === 1,
            'text-Pmin': i === 2,
            'text-P': i !== 1 && i !== 2
          }"
          [innerHTML]="text"></p>
      </div>
    </div>
    <div *ngIf="popUpInfo && popUpInfo.type == direction.horizontal">
      <div class="mx-2 my-2">
        <div class="my-2" *ngFor="let text of popUpInfo.texts; let i = index">
          <p class="text-P" *ngIf="i % 2 === 0">
            <b [innerHTML]="text"></b> : {{ popUpInfo.texts[i + 1] }}
          </p>
        </div>
      </div>
    </div>
  </ng-template>
</p-overlayPanel>
